/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `set_discharge_coefficients` - set_discharge_coefficients
 * * `set_crest_level` - set_crest_level
 * * `set_pump_capacity` - set_pump_capacity
 * * `set_gate_level` - set_gate_level
 * @export
 */
export const StructureControlActionTypeEnum = {
  SET_DISCHARGE_COEFFICIENTS: "set_discharge_coefficients",
  SET_CREST_LEVEL: "set_crest_level",
  SET_PUMP_CAPACITY: "set_pump_capacity",
  SET_GATE_LEVEL: "set_gate_level",
} as const;
export type StructureControlActionTypeEnum =
  (typeof StructureControlActionTypeEnum)[keyof typeof StructureControlActionTypeEnum];

export function instanceOfStructureControlActionTypeEnum(value: any): boolean {
  for (const key in StructureControlActionTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(StructureControlActionTypeEnum, key)) {
      if (
        StructureControlActionTypeEnum[key as keyof typeof StructureControlActionTypeEnum] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function StructureControlActionTypeEnumFromJSON(json: any): StructureControlActionTypeEnum {
  return StructureControlActionTypeEnumFromJSONTyped(json, false);
}

export function StructureControlActionTypeEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): StructureControlActionTypeEnum {
  return json as StructureControlActionTypeEnum;
}

export function StructureControlActionTypeEnumToJSON(
  value?: StructureControlActionTypeEnum | null
): any {
  return value as any;
}

export function StructureControlActionTypeEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): StructureControlActionTypeEnum {
  return value as StructureControlActionTypeEnum;
}
